import { createFileRoute } from "@tanstack/react-router";
import { ArbejdspladsPage, arbejdspladsHead } from "@/pages/ArbejdspladsPage";

export const Route = createFileRoute("/en/mi-support-as-a-workplace")({
  head: () => arbejdspladsHead("en"),
  component: () => <ArbejdspladsPage locale="en" />,
});
